import {
    ownersManagement
} from './modules/ownersManagement'
import {
    wechatMini
} from './modules/wechatMini'
const MemberLayOut = () => import( /*webpackChunkName:'member'*/ '@/page/member/memberLayOut.vue')
export const member = {
    path: '/member',
    name: '会员管理',
    component: MemberLayOut,
    redirect: '/main/user/userlist',
    children: [
        ownersManagement, 
        wechatMini
    ]

}